export const oldColors = [
    '#ec7e41',
    '#6bb0e5',

    '#cbda7c',
    '#d974a9',

    '#ff5151',
    '#fed853',

    '#948dff',
    '#382458',
    '#007f84',
    '#ff1d62',
    '#57769c',
]

export const LENS_COLORS = [
    '642fcf', // --lens-semantic-color-data-visualization-qualitative-purple-03
    '8b4bfa', // --lens-semantic-color-data-visualization-qualitative-purple-02
    'c247fa', // --lens-semantic-color-data-visualization-qualitative-purple-01
    'ff66a3', // --lens-semantic-color-data-visualization-sequential-negative-03
    'e6005c', // --lens-semantic-color-data-visualization-sequential-negative-04
    'a30041', // --lens-semantic-color-data-visualization-sequential-negative-05
    '00aaf3', // --lens-semantic-color-data-visualization-qualitative-blue-02
    '0086fa', // --lens-semantic-color-data-visualization-qualitative-blue-03
    '0b4cce', // --lens-semantic-color-data-visualization-qualitative-blue-04
    '00ccbb', // --lens-semantic-color-data-visualization-sequential-positive-03
    '00a89a', // --lens-semantic-color-data-visualization-sequential-positive-04
    '04655d', // --lens-semantic-color-data-visualization-sequential-positive-05
    'f5cc00', // --lens-semantic-color-data-visualization-sequential-neutral-03
    'e5a500', // --lens-semantic-color-data-visualization-sequential-neutral-04
    '9e6900', // --lens-semantic-color-data-visualization-sequential-neutral-05
]

export const LENS_COLORS_HEX = LENS_COLORS.map(color => `#${color}`)